import { useCallback } from "react";
import { Layout, useNotify, useRefresh } from "react-admin";
import { Menu } from "./Menu";
import AppBar from "./AppBar";
import {
  UploadJob,
  UploadManagerProvider,
} from "../uploads/UploadManager";
import UploadStatusPanel from "../uploads/UploadStatusPanel";

const MyLayout = (props: any) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const onCompleted = useCallback(
    (job: UploadJob) => {
      notify(`Contenido de ${job.request.userLabel} subido correctamente`, {
        type: "success",
      });
      refresh();
    },
    [notify, refresh]
  );
  const onFailed = useCallback(
    (job: UploadJob) => {
      notify(job.error || "No se pudo completar la subida", {
        type: "error",
      });
    },
    [notify]
  );

  return (
    <UploadManagerProvider onCompleted={onCompleted} onFailed={onFailed}>
      <Layout {...props} menu={Menu} appBar={AppBar} />
      <UploadStatusPanel />
    </UploadManagerProvider>
  );
};

export default MyLayout;
